export const getUniqueCategories = (menuItemsCategory) => {
  if (!menuItemsCategory) {
    return []
  }
  const categories: string[] = []
  Object.keys(menuItemsCategory).map((key) => categories.push(menuItemsCategory[key].category))
  const uniqueCategories = Array.from(new Set(categories))
  return uniqueCategories
}
